import HTTP, { unAuthHTTP } from "../utils/httpClient";
import * as types from "../types/authenticationType";
// import * as actionTypes from "../types/appType";
import configg from "../config";
import jwt_decode from "jwt-decode";
import setAuthToken from "../utils/setAuthToken";
import { getPersistedIssuers } from "./issuerAction";
import { getGlobalParameters } from "./globalParametersAction";
import moment from "moment";
// TODO: remove below
import { toastr } from "react-redux-toastr";
import { _sleep, reactReduxToastrOptions } from "constants/helper";

const config = {
    header: {
        "Content-Type": "application/json",
    },
};

const refreshToken = configg.isSessionStorage
    ? sessionStorage.getItem("rcpid")
    : localStorage.getItem("rcpid");
const setExpiresIn = (expires_in) => {
    configg.isSessionStorage
        ? sessionStorage.setItem("expires_in", expires_in)
        : localStorage.setItem("expires_in", expires_in);
};

const clearStorage = () => {
    const storeDataKeys = ["cpid", "rcpid", "expires_datetime", "expires_in"];
    for (let key of storeDataKeys) {
        configg.isSessionStorage ? sessionStorage.removeItem(key) : localStorage.removeItem(key);
    }
};

const saveIntoStorage = (obj) => {
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            configg.isSessionStorage
                ? sessionStorage.setItem(key, obj[key])
                : localStorage.setItem(key, obj[key]);
        }
    }
};

/****************************************************************************************************************************************
 *
 * @param {object} data
 * @param {function} callback
 * @returns
 */
export const login = (data, callback) => async (dispatch) => {
    // const BLACKLISTED_CORPORATE_ID = [4, 6, 19];
    const BLACKLISTED_CORPORATE_ID = [];
    try {
        const res = await unAuthHTTP.post(`/api/v1/token`, data, config);
        const { access_token, refresh_token, expires_in } = res.data.data;
        setAuthToken(access_token);
        const currentDateTime = moment().format();
        const expiresDateTime = moment(currentDateTime).add(expires_in - 120, "s");
        const duration = moment.duration(moment(expiresDateTime).diff(currentDateTime));
        const expiresSeconds = duration.asSeconds();

        const storeData = {
            cpid: access_token,
            rcpid: refresh_token,
            expires_datetime: expiresDateTime,
            expires_in: expiresSeconds,
        };

        /**
         * This persist the dark theme on login
         */
        /**
         * This decode the access token
         */
        const decoded = jwt_decode(access_token);
        const corporateId = decoded.corporate_id;

        if (BLACKLISTED_CORPORATE_ID?.includes(corporateId)) {
            toastr.success(
                "Redirecting...",
                `You will be redirected to Corporate Pay 3.0 shortly.`,
                reactReduxToastrOptions("top-right", 10_000)
            );
            await _sleep(5000);
            window.location.href = "https://ecorporatepay.etranzactng.net/";
            return;
        }
        /**
         * calling get issuer endpoint and persisting the state
         *
         */
        saveIntoStorage(storeData); // loop through storeData and save its keys into localStorage or sessionStorage
        dispatch(getPersistedIssuers());
        dispatch(getGlobalParameters());
        dispatch({
            type: types.LOGIN_USER,
            payload: {
                access_token,
                refresh_token,
                expires_in: expiresSeconds,
                expires_datetime: expiresDateTime,
                decoded,
            },
        });
    } catch (err) {
        if (err.response) {
            // callback();
            dispatch({
                type: types.INVALID_LOGIN_USER,
                payload: {
                    data: err.response.data,
                    msg: err.response.data.error,
                },
            });
        } else {
            // callback();
            dispatch({
                type: types.ERROR_LOGIN_USER,
                payload: "An error occur!!. Please check your network and try again later",
            });
        }
    } finally {
        callback();
    }
};

/****************************************************************************************************************************************
 * This function is use to re-login the user after change password without user logout
 * @param {object} data - {userSecret,username}
 * @param {function} callback
 * @returns
 */
export const relogin = (data, callback) => async (dispatch) => {
    try {
        const res = await unAuthHTTP.post(`/api/v1/token`, data, config);
        const { access_token, refresh_token, expires_in } = res.data.data;
        setAuthToken(access_token);
        const currentDateTime = moment().format();
        const expiresDateTime = moment(currentDateTime).add(expires_in - 120, "s");
        const duration = moment.duration(moment(expiresDateTime).diff(currentDateTime));
        const expiresSeconds = duration.asSeconds();
        const storeData = {
            cpid: access_token,
            rcpid: refresh_token,
            expires_datetime: expiresDateTime,
            expires_in: expiresSeconds,
        };
        saveIntoStorage(storeData); // loop through storeData and save its keys into localStorage or sessionStorage
        const decoded = jwt_decode(access_token);
        /**
         * storing "get issuer" in store and persisting the state
         */
        dispatch(getPersistedIssuers());
        /**
         * storing "global parameter" in store and persisting the state
         */
        dispatch(getGlobalParameters());

        dispatch({
            type: types.LOGIN_USER,
            payload: {
                access_token,
                refresh_token,
                expires_in: expiresSeconds,
                expires_datetime: expiresDateTime,
                decoded,
            },
        });
    } catch (err) {
        if (err.response) {
            callback();
            dispatch({
                type: types.INVALID_LOGIN_USER,
                payload: err.response.data.error,
            });
        } else {
            callback();
            dispatch({
                type: types.ERROR_LOGIN_USER,
                payload: "An error occur!!. Please check your network and try again later",
            });
        }
    }
};

/*************************************************************************************************************************************
 * This is use to reset login error and 2FA error response
 * @returns
 */
export const reset = () => (dispatch) => {
    dispatch({
        type: types.RESET,
    });
};
/*************************************************************************************************************************************
 *
 * @returns
 */
export const logout = () => (dispatch) => {
    window.location.href = "/";
    console.clear();
    clearStorage();
    dispatch({
        type: types.LOGOUT,
    });
};
/**************************************************************************************************************************************
 *
 * @param {*} param
 * @returns
 */
export const refreshTokenTime =
    ({ expires_in }) =>
    (dispatch) => {
        setExpiresIn(expires_in);
        dispatch({
            type: types.REFRESH_TOKEN_TIME,
            payload: {
                expires_in,
            },
        });
    };
/*****************************************************************************************************************************************
 * @returns
 */
export const refreshTokenCall = () => async (dispatch) => {
    try {
        const res = await HTTP.post(`/api/v1/token/refresh`, { refreshToken }, config);
        const { access_token, refresh_token, expires_in } = res.data.data;
        setAuthToken(access_token);
        const currentDateTime = moment().format();
        const expiresDateTime = moment(currentDateTime).add(expires_in - 120, "s");
        const duration = moment.duration(moment(expiresDateTime).diff(currentDateTime));
        const expiresSeconds = duration.asSeconds();
        clearStorage();
        const decoded = jwt_decode(access_token);
        /**
         * calling get issuer endpoint and persisting the state
         */
        // dispatch(getPersistedIssuers())
        dispatch({
            type: types.LOGIN_USER,
            payload: {
                access_token,
                refresh_token,
                expires_in: expiresSeconds,
                expires_datetime: expiresDateTime,
                decoded,
            },
        });
    } catch (error) {
        clearStorage();
        console.clear();
        window.location.href = "/";
        dispatch({
            type: types.LOGOUT,
        });
    }
};
/*******************************************************************************************************************************
 *
 * @param {object} - user
 * @returns
 */
export const updateSecurityQuestionTag =
    ({ user }) =>
    (dispatch) => {
        dispatch({
            type: types.UPDATE_SECURITY_QUESTION_TAG,
            payload: {
                user,
            },
        });
    };
